"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _time = require("../../../_helpers/time");

var _mobxReact = require("mobx-react");

var _react = _interopRequireWildcard(require("react"));

var _Text = _interopRequireDefault(require("../text/Text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const JUST_NOW = _time.TIME.ms.SECOND * 15;
const RelativeTimeText = (0, _mobxReact.observer)(({
  startDate,
  endDate,
  granularity = 'seconds',
  ...props
}) => {
  const generateTextDisplay = () => {
    const diff = ((endDate === null || endDate === void 0 ? void 0 : endDate.getTime()) || Date.now()) - startDate.getTime();

    if (diff < JUST_NOW) {
      return `Just now`;
    } else if (diff < _time.TIME.ms.MINUTE) {
      if (granularity === 'minutes') {
        return 'Just now';
      }

      const floor = Math.floor(diff / _time.TIME.ms.SECOND);
      return `${floor} second${floor > 1 ? 's' : ''} ago`;
    } else if (diff < _time.TIME.ms.HOUR) {
      const floor = Math.floor(diff / _time.TIME.ms.MINUTE);
      return `${floor} minute${floor > 1 ? 's' : ''} ago`;
    } else if (diff < _time.TIME.ms.DAY) {
      const floor = Math.floor(diff / _time.TIME.ms.HOUR);
      return `${floor} hour${floor > 1 ? 's' : ''} ago`;
    } else if (diff < _time.TIME.ms.MONTH) {
      const floor = Math.floor(diff / _time.TIME.ms.DAY);
      return `${floor} day${floor > 1 ? 's' : ''} ago`;
    } else if (diff < _time.TIME.ms.YEAR) {
      const floor = Math.floor(diff / _time.TIME.ms.MONTH);
      return `${floor} month${floor > 1 ? 's' : ''} ago`;
    } else {
      const floor = Math.floor(diff / _time.TIME.ms.YEAR);
      return `${floor} year${floor > 1 ? 's' : ''} ago`;
    }
  };

  const [displayText, setDisplayText] = (0, _react.useState)(generateTextDisplay());
  (0, _react.useEffect)(() => {
    setDisplayText(generateTextDisplay());

    if (!endDate) {
      const interval = Date.now() - startDate.getTime() < _time.TIME.ms.MINUTE ? _time.TIME.ms.SECOND : _time.TIME.ms.MINUTE;
      let timerid = setInterval(() => {
        setDisplayText(generateTextDisplay());

        if (interval === _time.TIME.ms.SECOND && Date.now() - startDate.getTime() > _time.TIME.ms.MINUTE) {
          clearInterval(timerid);
          timerid = setInterval(() => setDisplayText(generateTextDisplay()), _time.TIME.ms.MINUTE);
        }
      }, interval);
      return () => clearInterval(timerid);
    }
  }, [startDate, endDate]);
  return _react.default.createElement(_Text.default, { ...props
  }, displayText);
});
var _default = RelativeTimeText;
exports.default = _default;